export default function AllBrands() {
  const brands = ["Ferco", "GU", "Roto", "Maco", "Siegenia"];

  return (
    <section className="bg-white py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-[1280px] mx-auto">
        <div className="max-w-4xl">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif font-bold text-plum-dark mb-4 md:mb-6">
            Toutes marques de quincaillerie
          </h2>
          <p className="text-base md:text-lg text-plum-dark leading-relaxed mb-8 md:mb-10">
            Nos techniciens sont équipés de pièces neuves pour toutes les grandes marques de quincaillerie de fenêtre. Ils identifient la marque et le modèle sur place et installent la pièce adaptée.
          </p>
        </div>
        <div className="flex flex-wrap gap-3 md:gap-4">
          {brands.map((brand) => (
            <span
              key={brand}
              className="inline-flex items-center gap-2 bg-rose-50 rounded-xl px-4 py-3 border border-rose-100 text-sm md:text-base font-semibold text-plum-dark"
            >
              <i className="ri-check-line text-coral" />
              {brand}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}